var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ImagePlusIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 45,
    glyphHeight: 49,
    glyphOffsetY: 0
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M38.5 0C39.8807 0 41 1.11938 41 2.5V7H46.5C47.8807 7 49 8.11938 49 9.5C49 10.8806 47.8807 12 46.5 12H41V17.5C41 18.8806 39.8807 20 38.5 20C37.1193 20 36 18.8806 36 17.5V12H30.5C29.1193 12 28 10.8806 28 9.5C28 8.11938 29.1193 7 30.5 7H36V2.5C36 1.11938 37.1193 0 38.5 0ZM5 7H24.9C26.2808 7 27.4 5.88062 27.4 4.5C27.4 3.11938 26.2808 2 24.9 2H4.5C2.01477 2 0 4.01465 0 6.5V44.5C0 46.9854 2.01477 49 4.5 49H40.5C42.9852 49 45 46.9854 45 44.5V22.98C45 21.5994 43.8807 20.48 42.5 20.48C41.1193 20.48 40 21.5994 40 22.98V28.5378L31.7972 20.1609C30.075 18.4019 27.2592 18.3533 25.4772 20.0518L5 39.5698V7ZM39.7137 35.3918C39.8041 35.4841 39.8999 35.5681 40 35.6433V44H7.59875L28.5698 24.0115L39.7137 35.3918ZM14.5 21.5C17.2615 21.5 19.5 19.2615 19.5 16.5C19.5 13.7385 17.2615 11.5 14.5 11.5C11.7385 11.5 9.5 13.7385 9.5 16.5C9.5 19.2615 11.7385 21.5 14.5 21.5Z",
    fill: "black"
  }));
};
export var ImagePlusIconGlyph = function (props) {
  return React.createElement(ImagePlusIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};